<template lang="pug">
	.invoices-list
		template(v-if="$auth.countryCode() === 'US' && tab")
			template(v-if="$auth.isStationOwner()")
				.flex-col
					UploadingsList(v-if="tab.value === 'uploadings'", :hideHeader="true")
						.flex-row.space.wrap(slot="header")
							DxButton(:text="$tCaption('Invoices')", icon="fas fa-list-alt", stylingMode="text", @click="tab.value = 'invoices'", :hoverStateEnabled="true", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab.value === 'invoices' ? 'default' : 'normal'")
							DxButton(:text="$tCaption('Invoice upload')", icon="fas fa-upload", stylingMode="text", @click="tab.value = 'uploadings'", :hoverStateEnabled="true", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab.value === 'uploadings' ? 'default' : 'normal'")
					InvoicesList(v-if="tab.value === 'invoices'", :isStationOwner="true", :hideHeader="true")
						.flex-row.space.wrap(slot="header")
							DxButton(:text="$tCaption('Invoices')", icon="fas fa-list-alt", stylingMode="text", @click="tab.value = 'invoices'", :hoverStateEnabled="true", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab.value === 'invoices' ? 'default' : 'normal'")
							DxButton(:text="$tCaption('Invoice upload')", icon="fas fa-upload", stylingMode="text", @click="tab.value = 'uploadings'", :hoverStateEnabled="true", :activeStateEnabled="false", :focusStateEnabled="false", :type="tab.value === 'uploadings' ? 'default' : 'normal'")
			InvoicesList(v-else)
</template>

<script>
	import InvoicesList from './InvoicesList.vue';
	import UploadingsList from './UploadingsList.vue';
	import DxButton from 'devextreme-vue/button';
	import storage from 'storage';

	export default {
		translationCategory: 'invoice.List',
		name: 'invoices-list',
		components: {
			InvoicesList, UploadingsList, DxButton
		},
		data() {
			return {
				tab: storage.prop('invoice-uploadings-tab', void 0, 'uploadings')
			}
		},
		created() {
			if (__DEBUG__)
				window.invoicesList = this;
		}
	};
</script>
<style lang='scss'>
	.invoices-list {
		.buttons-group {
			margin-top: 10px;
		}
	}
</style>
